import PropTypes from "prop-types";

const Heading = ({ children }) => <h4>{children}</h4>;

Heading.propTypes = { children: PropTypes.any };

export default Heading;
